<div class="container">
    <div class="topheadtitle">
        <h4 id="hourly-usage-title">Hourly Usage Report </h4>
    </div>

    <div style="display: block;">
        <canvas baseChart title="Hourly Usage Report Chart" [type]="'line'" [data]="lineChartData"
            [options]="lineChartOptions" [legend]="lineChartLegend" [attr.role]="'img'"
            [attr.aria-labelledby]="'hourly-usage-title hourly-usage-desc'">
            Hourly Usage Report line chart.
        </canvas>
        <p id="hourly-usage-desc" class="visually-hidden">
            Line chart showing usage by hour.
        </p>
    </div>
</div>
